import {connect} from 'react-redux';
import {CACHE as LOADING_CACHE} from '../../components/common/loading';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import DynamicDestinationRefinementsComponent from './DynamicDestinationRefinements';
import {moduleLoaded, moduleHidden} from '../../reducers/moduleStatus';

const mapStateToProps = (state) => {
    const {
        config: {
            template,
            url: {basePathPrefix},
            context: {isBot},
        },
        destination: {
            details: {lbsId},
        },
        options: {destinationRefinementsMode, allowBrandedHeadings},
        marketingLocalization: {preposition},
        hasTouch,
    } = state;

    return {
        basePathPrefix,
        lbsId,
        template,
        isBot,
        mode: destinationRefinementsMode,
        allowBrandedHeadings,
        preposition,
        hasTouch,
    };
};

export const mapDispatchToProps = {moduleLoaded, moduleHidden};

const DynamicDestinationRefinements = connect(
    mapStateToProps,
    mapDispatchToProps
)(determineIfMobile(DynamicDestinationRefinementsComponent));

DynamicDestinationRefinements.displayName = 'DynamicDestinationRefinements';

LOADING_CACHE.set(DynamicDestinationRefinements, {
    componentType: 'DynamicDestinationRefinements',
    placeholderType: 'Carousel',
});

export default DynamicDestinationRefinements;
